import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import CommandsContainer from '../../../components/AlertsGrid/Commands/CommandsContainer';

// Constants
import { APP_TITLE } from '../../../utils/constants';
import { GetString } from '../../../components/StringResourceManager';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import { Dispatch } from 'redux';
import { useEffect } from 'react';
import { getDivisionList } from '../../../store/Assets/AssetsActions';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto',
    },
  }),
);

export default function CommandsSubMenu() {
  const classes = useStyles();
  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getDivisionList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_COMMANDS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header open={true} pageDisplayed={GetString('PAGE_TITLE_COMMANDS')} />
      <Paper className={classes.paperGrid}>
        <CommandsContainer />
      </Paper>
    </>
  );
}
